import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Employee, EmployeeType, Country, Provincia, Comune, Company } from 'toolbandi-ui-lib';
import { CrudService, MessageService, SharedDataService, ListService } from 'elbuild-ui-lib-core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-employee-salary-edit',
	templateUrl: './employee-salary-edit.component.html',
	styleUrls: ['./employee-salary-edit.component.scss']
})
export class EmployeeSalaryEditComponent implements OnInit, OnDestroy {


	loading: boolean = true;
	employee: Employee;

	editable: boolean = true;

	@Input()
	companyid: number;

	title: string;

	types = Object.keys(EmployeeType).map(t => EmployeeType[t]);


	constructor(
		private crudService: CrudService<Employee>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private sharedDataService: SharedDataService,
		private route: ActivatedRoute,
		private router: Router,
		private activeModal: NgbActiveModal
	) {
	}

	ngOnInit() {

		this.route.params.subscribe(params => {
			const id = +params['id'];
			if (id) {
				this.load(id);
			}

		});
	}

	ngOnDestroy() {
		this.sharedDataService.addCommonData('route', undefined);
	}

	load(id: number) {
		this.loading = true;
		this.crudService.getEntity(Employee, 'employee', id).subscribe(employee => {
			this.employee = employee;
			this.title = 'employee-salary-edit';
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.employee'));
			this.employee = undefined;
			this.loading = false;
		});
	}

	dismiss() {
		this.activeModal.dismiss();
	}


	submit() {

		this.crudService.saveEntity(Employee, 'employee', this.employee).subscribe(response => {
			this.employee = response;
			const messages = this.translateService.instant(['labels.employee-save-success', 'labels.success']);
			this.messageService.sendSuccess(messages['labels.employee-save-success'], messages['labels.success']);
			this.activeModal.close(this.employee);
		}, ({ error }) => {
			this.messageService.sendError(
				error.msg ? error.msg : error,
				this.translateService.instant('labels.event-save-error')
			);
		});
	}

	resetFields(): void {
		this.employee.rateo = undefined;
		this.employee.contracthour = undefined;
		this.employee.contractleave = undefined;
		this.employee.inps = undefined;
		this.employee.inail = undefined;
		this.employee.basesalary = undefined;
		this.employee.payurl = undefined;
		this.employee.yearlyhour = undefined;
		this.employee.yearlysalary = undefined;
		this.employee.oneri = undefined;
	}




}
